function getDisplayName(input: any) {
  if (!input) {
    return "";
  }

  return [input.firstName, input.lastName].filter((i) => Boolean(i)).join(" ");
}

export default getDisplayName;
